import * as React from 'react';
import { flow, get } from 'lodash';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Button, Col, ControlLabel, Form, FormGroup, InputGroup, Modal, } from 'react-bootstrap';
import { ITraveller } from '../../../../../../data/api/models';
import { IAuthState } from '../../../../../../services/auth/models';
import { connect } from 'react-redux';
import { IQuoteActions, IQuoteState } from '../../../../../../services/quote/models';
import SelectControl from '../../../../../../components/SelectControl';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import Loading from '../../../../../../components/Loading';
import { FormattedNumber } from 'react-intl';
import { actions as authActions, IAuthActions } from '../../../../../../services/auth/reducer';
import { push } from 'react-router-redux';

interface ISaveQuoteFormProps {
  travellers: ITraveller[];
  auth: IAuthState;
  quote: IQuoteState;
  onGoToMyAccount: any;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  isQuoteSaved: boolean;
  formValues: any;
  actions: {
    quote: IQuoteActions;
    auth: IAuthActions;
  };
  handleEditQuote: any;
  selectedQuote: any;
  values: any;
  toggleCustomerLapsed: any;
  customerLapsed: boolean;
}

interface ICancelRenewalFormState {
  appliedCampaign: boolean;
  discountedPremiumPrice: number;
  fetchingData: boolean;
  discountAlreadyApplied: boolean;
  lapsed: boolean;
  acceptedCampaignOffer: boolean;
  cancellingRenewal: boolean;
  lapsingError: boolean;
}

class CancelRenewalForm extends React.Component<ISaveQuoteFormProps, ICancelRenewalFormState> {
  public state = {
    appliedCampaign: false,
    discountedPremiumPrice: null,
    fetchingData: false,
    discountAlreadyApplied: false,
    lapsed: false,
    acceptedCampaignOffer: false,
    cancellingRenewal: false,
    lapsingError: false,
  };

  public applyPriceCampaign = () => {
    const {actions, quote, selectedQuote} = this.props;

    // If there is already a discount on the application then don't offer them a discount
    if (quote.application.campaignCode && quote.application.campaignCode !== 'QO015') {
      this.setState({discountAlreadyApplied: true});
      return;
    }

    // Only try to apply the campaign once per modal opening
    if (this.state.appliedCampaign || this.state.discountedPremiumPrice || this.state.fetchingData) {
      return;
    }

    this.setState({fetchingData: true});

    // Renewal discount code if price is selected as an option
    selectedQuote.campaignCode = 'QO015';

    Promise.resolve(actions.quote.calculate(selectedQuote, false)).then((response) => {
      this.setState({discountedPremiumPrice: response.premiums[0].gross});
      this.setState({appliedCampaign: true});
      this.setState({fetchingData: false});
    });

  }

  public componentDidMount(): void {
    this.forceUpdate();
  }

  public componentDidUpdate(prevProps: Readonly<ISaveQuoteFormProps>, prevState: Readonly<ICancelRenewalFormState>,
                            prevContext: any): void {
    const {
      formValues,
    } = this.props;

    if (get(formValues, 'reason.customer_lapse_reason') === 'Price' && !this.state.appliedCampaign
      && !this.state.discountedPremiumPrice && !this.state.discountAlreadyApplied) {
      this.applyPriceCampaign();
    }
  }

  public lapseRenewal = () => {
    this.setState({lapsingError: false});
    const {actions, selectedQuote, formValues, toggleCustomerLapsed} = this.props;
    this.setState({cancellingRenewal: true});
    actions.quote.lapseRenewal(selectedQuote.id, formValues).then(() => {
      this.setState({lapsed: true});
      this.setState({cancellingRenewal: false});
      toggleCustomerLapsed();
      const promises = [];
      promises.push(actions.auth.reloadCustomer());
      return Promise.all(promises);
    }, () => {
      this.setState({lapsingError: true});
    });
  }

  public acceptedCampaignOffer = () => {
    this.setState({acceptedCampaignOffer: true});
  }

  public render() {

    const reasons = [
      {label: 'Price', value: 'Price'},
      {label: 'I\'ve bought another policy', value: 'I\'ve bought another policy'},
      {label: 'I\'m not travelling this year', value: 'I\'m not travelling this year'},
      {label: 'I\'m only travelling once this year', value: 'I\'m only travelling once this year'},
      {label: 'Poor Service', value: 'Poor Service'},
      {label: 'Other', value: 'Other'},
    ];

    const alternativeInsurers = [
      {label: 'AA', value: 'AA'},
      {label: 'Aviva', value: 'Aviva'},
      {label: 'AXA', value: 'AXA'},
      {label: 'Cedar Tree', value: 'Cedar Tree'},
      {label: 'Columbus', value: 'Columbus'},
      {label: 'Debenhams', value: 'Debenhams'},
      {label: 'Direct Line', value: 'Direct Line'},
      {label: 'ERV', value: 'ERV'},
      {label: 'Esure', value: 'Esure'},
      {label: 'Fortify', value: 'Fortify'},
      {label: 'Insure and go', value: 'Insure and go'},
      {label: 'Insurefor', value: 'Insurefor'},
      {label: 'L+G', value: 'L+G'},
      {label: 'Morethan', value: 'Morethan'},
      {label: 'Post Office', value: 'Post Office'},
      {label: 'Puffin', value: 'Puffin'},
      {label: 'RAC', value: 'RAC'},
      {label: 'Saga', value: 'Saga'},
      {label: 'Stay Sure', value: 'Stay Sure'},
      {label: 'Thomas Cook', value: 'Thomas Cook'},
      {label: 'Top Dog', value: 'Top Dog'},
      {label: 'Virgin', value: 'Virgin'},
      {label: 'My Bank', value: 'My Bank'},
      {label: 'Other', value: 'Other'},
    ];

    const alternativeInsurersToShowFreeText = ['My Bank', 'Other'];

    const reasonsAlternateInsuranceTriggers = ['I\'ve bought another policy'];
    const reasonsFreeTextTriggers = ['Poor Service', 'Other'];
    const reasonsCouponMessage = ['I\'m not travelling this year', 'I\'m only travelling once this year'];

    const {
      formValues,
      handleEditQuote,
      quote,
    } = this.props;

    if (this.state.lapsingError) {
      return (
        <Modal.Body>
          <div className="text-center cancel-loader">
            <p>
              An error occurred while trying to cancel your renewal, please contact us.
            </p>
          </div>
        </Modal.Body>
      );
    }

    if (this.state.cancellingRenewal) {
      return (
        <Modal.Body>
          <div className="text-center cancel-loader">
            <Loading/>
            <p>
              Loading, please wait while we cancel your renewal...
            </p>
          </div>
        </Modal.Body>
      );
    }

    if (this.state.lapsed) {
      return (
        <Modal.Body>
          <p>Your Travel Insurance renewal is now set to lapse. An email confirmation will be sent to you.</p>
          {reasonsCouponMessage.includes(get(formValues, 'reason.customer_lapse_reason')) &&
          <div>
            <p>As a thank you for your loyalty please use the discount code below for 20% off your next
              Travel Insurance purchase with us (Note: Discount code is valid for 90 days).</p>
            <p className="bold">
              LOYALTY20
            </p>
          </div>
          }
        </Modal.Body>
      );
    }

    if (this.state.acceptedCampaignOffer) {
      return (
        <Modal.Body>
          Great! We just need you to review your renewal information. If you are happy that all the information is up
          to date and correct your new price will be on the payment page.
          Please be aware any changes you make to your policy may change the price offered above.
          Please <span className="clickable-text" onClick={handleEditQuote}>click here</span> to review your renewal.
        </Modal.Body>
      );
    }

    return (
      <Form horizontal={true} autoComplete="off">
        <Modal.Body>

          <FormGroup className="lapse-reasons">
            <Col componentClass={ControlLabel} sm={5}>
              Renewal Cancellation Reason
            </Col>
            <Col sm={7} className="lapse-reason">
              <Field
                name="meta.reason.customer_lapse_reason"
                id="destinations-inputs"
                type="text"
                component={SelectControl}
                options={reasons}
              />
            </Col>
          </FormGroup>
          {reasonsAlternateInsuranceTriggers.includes(get(formValues, 'reason.customer_lapse_reason')) && (
            <div>
              <hr/>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={5}>
                  Alternative Insurer Name
                </Col>
                <Col sm={7}>
                  <Field
                    name="meta.reason.alternative_insurer_name"
                    id="alternative-insurer-name"
                    type="text"
                    placeholder="Insurer Name"
                    component={SelectControl}
                    options={alternativeInsurers}
                  />
                </Col>
              </FormGroup>

              {alternativeInsurersToShowFreeText.includes(get(formValues, 'reason.alternative_insurer_name')) && (
                <div>
                  <FormGroup>
                    <Col componentClass={ControlLabel} sm={5}/>
                    <Col sm={7}>
                      <Field
                        name="meta.reason.freetype_alterative_insurer_name"
                        id="other-cancellation-reason"
                        type="text"
                        className="form-control"
                        placeholder="Please enter their name"
                        component={FieldFormControl}
                      />
                    </Col>
                  </FormGroup>
                </div>
              )}

              <FormGroup>
                <Col componentClass={ControlLabel} sm={5}>
                  Alternative Insurer Price
                </Col>
                <Col sm={7}>
                  <InputGroup className="mb-3">
                    <InputGroup.Addon>£</InputGroup.Addon>
                    <Field
                      name="meta.reason.alternative_insurer_price"
                      id="alternative-insurer-price"
                      type="text"
                      className="form-control"
                      placeholder="Alternative Insurer Price"
                      component={FieldFormControl}
                    />

                  </InputGroup>
                </Col>
              </FormGroup>
            </div>
          )}

          {reasonsFreeTextTriggers.includes(get(formValues, 'reason.customer_lapse_reason')) && (
            <div>
              <hr/>
              {get(formValues, 'reason.customer_lapse_reason') === 'Poor Service' &&
              <p>We are really sorry to hear this. Please let us know how we can do better next time.</p>
              }
              <FormGroup>
                <Col componentClass={ControlLabel} sm={5}>
                  Please let us know why
                </Col>
                <Col sm={7}>
                  <Field
                    name="meta.reason.other_cancellation_reason"
                    id="other-cancellation-reason"
                    type="text"
                    className="form-control"
                    placeholder="Cancellation reason"
                    component={FieldFormControl}
                  />
                </Col>
              </FormGroup>
            </div>
          )}

          {get(formValues, 'reason.customer_lapse_reason')
          && get(formValues, 'reason.customer_lapse_reason') === 'Price'
          && this.state.discountedPremiumPrice && !this.state.discountAlreadyApplied && (
            <div className="button-bar">
              <hr/>
              <p>We are sorry to hear that you're unhappy with the price offered for your renewal this year.
                As you have been a loyal customer with us for 12 months we are happy to include a
                {' '}<span className="bold">15% discount</span>{' '}
                on your Renewal Quote. Your new renewal price including your Insurance Premium Tax of 20%
                will be{' '}
                <FormattedNumber
                  value={this.state.discountedPremiumPrice}
                  style="currency"
                  currency={quote.application.premiums[0].currency}
                />.</p>
              <hr/>
              <p className="bold">Are you happy to accept this new price?</p>
              <div className="button-bar">
                <Button
                  bsStyle="primary"
                  onClick={this.acceptedCampaignOffer}
                  className="button-bar__yes"
                >
                  YES
                </Button>

                <Button
                  bsStyle="default"
                  onClick={this.lapseRenewal}
                  className="button-bar__no"
                >
                  NO - I'd still like to cancel my renewal
                </Button>
              </div>
            </div>
          )}

          {get(formValues, 'reason.customer_lapse_reason')
          && get(formValues, 'reason.customer_lapse_reason') === 'Price'
          && !this.state.discountedPremiumPrice && !this.state.discountAlreadyApplied && (
            <div className="text-center cancel-loader">
              <Loading/>
              <p>
                Loading, please wait...
              </p>
            </div>
          )}

          {(get(formValues, 'reason.customer_lapse_reason')
            && get(formValues, 'reason.customer_lapse_reason') !== 'Price'
            || (
              this.state.discountAlreadyApplied
              && get(formValues, 'reason.customer_lapse_reason') === 'Price'
            )) && (
            <div>
              <hr/>
              <p className="bold">Are you sure you want to cancel your renewal?</p>
              <div className="button-bar">
                <Button
                  bsStyle="primary"
                  onClick={this.lapseRenewal}
                  className="button-bar__yes"
                >
                  YES
                </Button>

                <Button
                  bsStyle="default"
                  onClick={this.props.onCloseModal}
                  className="button-bar__no"
                >
                  NO
                </Button>
              </div>
            </div>
          )}

        </Modal.Body>
      </Form>
    );
  }
}

const validate = () => {
  return {};
};

const selector = formValueSelector('cancel_renewal');

export default flow([
  reduxForm({
    form: 'cancel_renewal',
    validate,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (state) => {
      const values = selector(state,
        'meta',
      );

      return {
        formValues: values,
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({...authActions}, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(CancelRenewalForm);
